<template>
  <BannerBlock titleClass>
    <template v-slot:title>{{$t("banner.guideReview")}}</template>
    <template v-slot:message>
      <p>
        <b>{{$t("banner.thankFor")}}</b>
      </p>
      {{$t("banner.guideReviewDesc")}}
    </template>
    <template v-slot:actions>
      <a
        href="https://apps.shopify.com/gempages#modal-show=ReviewListingModal"
        target="_blank"
        class="btn btn-g-info"
      >{{$t("generals.review")}} {{$t("generals.now")}}</a>
    </template>
    <template v-slot:default>
      <!-- <div class="bg ml-auto col-sm-4 d-none d-sm-unset"></div> -->
      <div class="banner-image col-sm-5 d-none d-sm-flex">
        <img class="banner-img" :src="publicPath + require('@/core/assets/Dashboard/Banner/Guide/review.svg')" />
      </div>
    </template>
  </BannerBlock>
</template>

<script>
import BannerBlock from "../../BannerBlock";
export default {
  name: "GuideReview",
  components: {
    BannerBlock
  },
  data() {
    return {
      // dayLeft: 2
    };
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
// .bg {
//   background-image: url(~@/core/assets/Dashboard/Banner/Guide/review.svg);
//   width: 288px;
// }
</style>
